import { format } from "date-fns";
import { useState } from "react";
import Input from "../../components/custom/forms/Input";
import { SalaImages } from "../../../utils/SalaUtils";

const Usuario = ({ data, facturacion, provincias, onClick, onChange, filePreview }) => {
  const [activeTab, setActiveTab] = useState('datos-basicos');
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);

  // Verificar si es espectador
  const isEspectador = data?.tipo === 'esp' || data?.rol?.[0]?.nombre === 'esp';

  return (
    <div className="container-fluid px-md-5 py-4">
      {/* Header Section */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="bg-white shadow-sm rounded-3 p-4">
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div className="d-flex align-items-center gap-3">
                <div>
                  <h2 className="mb-1 d-flex align-items-center gap-2">
                    {data.id ? `Usuario #${data.id}` : "Nuevo Usuario"}
                  </h2>
                  <div className="d-flex gap-2 align-items-center text-muted">
                    <span className={`badge ${data.status.nombre === 'Activo' ? 'bg-success' : 'bg-secondary'}`}>
                      <i className="bi bi-circle-fill me-1" style={{fontSize: '8px'}}></i>
                      {data.status.nombre}
                    </span>
                    <span className="small">
                      <i className="bi bi-calendar3 me-1"></i>
                      Creado: {format(new Date(data.created_at), "dd/MM/yyyy")}
                    </span>
                  </div>
                </div>
              </div>
              <div>
                <button
                  className="btn btn-primary px-4 py-2 shadow-sm"
                  name={`${data.id ? "aplicar" : "guardar"}`}
                  onClick={(event) => onClick(event)}
                >
                  <i className="bi bi-check-circle me-2"></i>
                  {`${data.id ? "Aplicar cambios" : "Guardar usuario"}`}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Navigation */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="bg-white shadow-sm rounded-3 p-3">
            <ul className="nav nav-pills nav-fill gap-2" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === 'datos-basicos' ? 'active' : ''}`}
                  onClick={() => setActiveTab('datos-basicos')}
                  style={{borderRadius: '8px'}}
                >
                  <i className="bi bi-person-circle me-2"></i>
                  Datos Básicos
                </button>
              </li>
              {(data?.tipo === "prd" || data?.rol[0].nombre === "prd") && (
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === 'datos-productor' ? 'active' : ''}`}
                    onClick={() => setActiveTab('datos-productor')}
                    style={{borderRadius: '8px'}}
                  >
                    <i className="bi bi-briefcase me-2"></i>
                    Datos de Productor
                  </button>
                </li>
              )}
              {(data?.tipo === "sala" || data?.rol[0].nombre === "sala") && (
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === 'datos-sala' ? 'active' : ''}`}
                    onClick={() => setActiveTab('datos-sala')}
                    style={{borderRadius: '8px'}}
                  >
                    <i className="bi bi-building me-2"></i>
                    Datos de Sala
                  </button>
                </li>
              )}
              {!isEspectador && (
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === 'facturacion' ? 'active' : ''}`}
                    onClick={() => setActiveTab('facturacion')}
                    style={{borderRadius: '8px'}}
                  >
                    <i className="bi bi-receipt me-2"></i>
                    Facturación
                  </button>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="row">
        <div className="col-12">
          {/* Datos Básicos Tab */}
          {activeTab === 'datos-basicos' && (
            <div className="bg-white shadow-sm rounded-3 p-4">
              <h5 className="mb-4 pb-2 border-bottom d-flex align-items-center">
                <i className="bi bi-person-circle text-secondary me-2"></i>
                Información Personal
              </h5>
              <div className="row">
                <div className="col-md-12 mb-4">
                  <div className="card border-0 bg-light">
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-md-auto mb-3 mb-md-0">
                          <div
                            className="overflow-hidden shadow-sm border border-2 border-white"
                            style={{
                              height: "180px",
                              width: "180px",
                              borderRadius: "12px",
                            }}
                          >
                            <img
                              src={data.imagen_logo}
                              alt="Avatar"
                              className="w-100 h-100"
                              style={{ objectFit: "cover" }}
                            />
                          </div>
                        </div>
                        <div className="col-md">
                          <label className="form-label d-flex align-items-center mb-2">
                            <i className="bi bi-image me-2 text-secondary"></i>
                            <strong>Imagen de perfil</strong>
                          </label>
                          <p className="text-muted small mb-2">
                            <i className="bi bi-info-circle me-1"></i>
                            Tamaño recomendado: 1080 x 1080 px (formato cuadrado)
                          </p>
                          <Input
                            onChange={onChange}
                            name={"imagen_logo"}
                            type={"file"}
                            value={""}
                            svg={'<i class="bi bi-upload"></i>'}
                            validate={{}}
                            disabled={false}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <Input
                    onChange={onChange}
                    label={"Nombre"}
                    name={"nombre"}
                    type={"text"}
                    value={data?.nombre}
                    svg={'<i class="bi bi-person"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <Input
                    onChange={onChange}
                    label={"Apellido"}
                    name={"apellido"}
                    type={"text"}
                    value={data?.apellido}
                    svg={'<i class="bi bi-person"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <Input
                    onChange={onChange}
                    label={"Teléfono"}
                    name={"telefono"}
                    type={"tel"}
                    value={data?.telefono}
                    svg={'<i class="bi bi-telephone"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <Input
                    onChange={onChange}
                    label={"Email"}
                    name={"email"}
                    type={"email"}
                    value={data?.email}
                    svg={'<i class="bi bi-envelope"></i>'}
                    validate={{}}
                    disabled={data?.id ? true : false}
                  />
                  {data?.id && (
                    <small className="text-muted">
                      <i className="bi bi-lock me-1"></i>
                      El email no se puede modificar
                    </small>
                  )}
                  {!data?.id && (
                    <small className="text-muted">
                      <i className="bi bi-info-circle me-1"></i>
                      Este email será usado para el login
                    </small>
                  )}
                </div>
                <div className="col-md-6 col-12 my-2">
                  <label className="form-label d-flex align-items-center mb-2">
                    <i className="bi bi-shield-check text-secondary me-2"></i>
                    <strong>Tipo de usuario {!data?.id && <span className="text-danger ms-1">*</span>}</strong>
                  </label>
                  <select
                    className="form-select border shadow-sm"
                    name="tipo"
                    value={data?.tipo || ""}
                    onChange={(e) => onChange(e)}
                    disabled={data?.id ? true : false}
                  >
                    <option value="">{data?.rol[0].descripcion}</option>
                    {[
                      { label: "Administrador", value: "adm" },
                      { label: "Espectador", value: "esp" },
                      { label: "Sala", value: "sala" },
                      { label: "Productor", value: "prd" },
                    ].map((tipo, idx) => (
                      <option key={idx} value={tipo.value}>{tipo.label}</option>
                    ))}
                  </select>
                  {!data?.id && (
                    <small className="text-muted">
                      <i className="bi bi-info-circle me-1"></i>
                      El tipo no se puede cambiar después de crear el usuario
                    </small>
                  )}
                </div>
              </div>

              <h5 className="mb-3 mt-4 pb-2 border-bottom d-flex align-items-center">
                <i className="bi bi-geo-alt text-secondary me-2"></i>
                Ubicación
              </h5>
              <div className="row">
                <div className="col-md-6 col-12">
                  <Input
                    onChange={onChange}
                    label={"Dirección"}
                    name={"direccion"}
                    type={"text"}
                    value={data?.direccion}
                    svg={'<i class="bi bi-house-door"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <Input
                    onChange={onChange}
                    label={"Localidad"}
                    name={"localidad"}
                    type={"text"}
                    value={data?.localidad}
                    svg={'<i class="bi bi-geo"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-6 col-12 my-2">
                  <label className="form-label d-flex align-items-center mb-2">
                    <i className="bi bi-map text-secondary me-2"></i>
                    <strong>Provincia</strong>
                  </label>
                  <select
                    className="form-select border shadow-sm"
                    name="provincia"
                    onChange={(e) => onChange(e)}
                  >
                    <option selected>{data?.provincia}</option>
                    {provincias.map((provincia, idx) => (
                      <option key={idx} value={provincia.provincia}>
                        {provincia.provincia}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <h5 className="mb-3 mt-4 pb-2 border-bottom d-flex align-items-center">
                <i className="bi bi-key text-secondary me-2"></i>
                Seguridad
              </h5>
              {data?.id ? (
                <div className="alert alert-info d-flex align-items-center mb-3">
                  <i className="bi bi-info-circle-fill me-2"></i>
                  <small>Deja estos campos vacíos si no deseas cambiar la contraseña</small>
                </div>
              ) : (
                <div className="alert alert-warning d-flex align-items-center mb-3">
                  <i className="bi bi-exclamation-triangle-fill me-2"></i>
                  <small>La contraseña es obligatoria para nuevos usuarios</small>
                </div>
              )}
              <div className="row">
                <div className="col-md-6 col-12">
                  <label className="form-label d-flex align-items-center mb-2">
                    <i className="bi bi-lock text-secondary me-2"></i>
                    <strong>Nueva contraseña</strong>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text bg-white">
                      <i className="bi bi-lock"></i>
                    </span>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control border-start-0"
                      name="password"
                      value={data?.password || ""}
                      onChange={onChange}
                      placeholder="Ingrese la contraseña"
                    />
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      title={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                    >
                      <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                    </button>
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <label className="form-label d-flex align-items-center mb-2">
                    <i className="bi bi-lock-fill text-secondary me-2"></i>
                    <strong>Repetir contraseña</strong>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text bg-white">
                      <i className="bi bi-lock-fill"></i>
                    </span>
                    <input
                      type={showRepeatPassword ? "text" : "password"}
                      className="form-control border-start-0"
                      name="repeat_password"
                      value={data?.repeat_password || ""}
                      onChange={onChange}
                      placeholder="Repita la contraseña"
                    />
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={() => setShowRepeatPassword(!showRepeatPassword)}
                      title={showRepeatPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                    >
                      <i className={`bi ${showRepeatPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Datos Productor Tab */}
          {activeTab === 'datos-productor' && (data?.tipo === "prd" || data?.rol[0].nombre === "prd") && (
            <div className="bg-white shadow-sm rounded-3 p-4">
              <h5 className="mb-4 pb-2 border-bottom d-flex align-items-center">
                <i className="bi bi-briefcase text-secondary me-2"></i>
                Información del Productor
              </h5>
              <div className="row">
                <div className="col-md-12 col-12">
                  <Input
                    onChange={onChange}
                    label={"Nombre del productor"}
                    name={"productor-nombre"}
                    type={"text"}
                    value={data?.productor?.nombre}
                    svg={'<i class="bi bi-briefcase"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <Input
                    onChange={onChange}
                    label={"Teléfono"}
                    name={"productor-telefono"}
                    type={"tel"}
                    value={data?.productor?.telefono}
                    svg={'<i class="bi bi-telephone"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <Input
                    onChange={onChange}
                    label={"Email"}
                    name={"productor-email"}
                    type={"email"}
                    value={data?.productor?.prd_email}
                    svg={'<i class="bi bi-envelope"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-4 col-12">
                  <Input
                    onChange={onChange}
                    label={"Dirección"}
                    name={"productor-direccion"}
                    type={"text"}
                    value={data?.productor?.direccion}
                    svg={'<i class="bi bi-house-door"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-4 col-12">
                  <Input
                    onChange={onChange}
                    label={"Localidad"}
                    name={"productor-localidad"}
                    type={"text"}
                    value={data?.productor?.localidad}
                    svg={'<i class="bi bi-geo"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-4 col-12 my-2">
                  <label className="form-label d-flex align-items-center mb-2">
                    <i className="bi bi-map text-secondary me-2"></i>
                    <strong>Provincia</strong>
                  </label>
                  <select
                    className="form-select border shadow-sm"
                    name="productor-provincia"
                    onChange={(e) => onChange(e)}
                  >
                    <option selected>{data?.productor?.provincia}</option>
                    {provincias.map((provincia, idx) => (
                      <option key={idx} value={provincia.provincia}>
                        {provincia.provincia}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          )}

          {/* Datos Sala Tab */}
          {activeTab === 'datos-sala' && (data?.tipo === "sala" || data?.rol[0].nombre === "sala") && (
            <div className="bg-white shadow-sm rounded-3 p-4">
              <h5 className="mb-4 pb-2 border-bottom d-flex align-items-center">
                <i className="bi bi-building text-secondary me-2"></i>
                Información de la Sala
              </h5>
              <div className="row">

                <div className="col-md-12 mb-4">
                  <div className="card border-0 bg-light">
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-md-auto mb-3 mb-md-0">
                          <div
                            className="overflow-hidden shadow-sm border border-2 border-white"
                            style={{
                              height: "180px",
                              width: "180px",
                              borderRadius: "12px",
                            }}
                          >
                            <img
                              src={data?.sala?.imagen_logo}
                              alt="Logo Sala"
                              className="w-100 h-100"
                              style={{ objectFit: "cover" }}
                            />
                          </div>
                        </div>
                        <div className="col-md">
                          <label className="form-label d-flex align-items-center mb-2">
                            <i className="bi bi-image me-2 text-secondary"></i>
                            <strong>Imagen principal de la sala</strong>
                          </label>
                          <p className="text-muted small mb-2">
                            <i className="bi bi-info-circle me-1"></i>
                            Tamaño recomendado: 1080 x 1080 px
                          </p>
                          <Input
                            onChange={onChange}
                            name={"sala-imagen_logo"}
                            type={"file"}
                            value={""}
                            svg={'<i class="bi bi-upload"></i>'}
                            validate={{}}
                            disabled={false}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-12 col-12">
                  <Input
                    onChange={onChange}
                    label={"Nombre de la sala"}
                    name={"sala-razon_social"}
                    type={"text"}
                    value={data?.sala?.razon_social}
                    svg={'<i class="bi bi-building"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <Input
                    onChange={onChange}
                    label={"Teléfono"}
                    name={"sala-telefono"}
                    type={"tel"}
                    value={data?.sala?.telefono}
                    svg={'<i class="bi bi-telephone"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <Input
                    onChange={onChange}
                    label={"Email"}
                    name={"sala-email"}
                    type={"email"}
                    value={data?.sala?.email}
                    svg={'<i class="bi bi-envelope"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-4 col-12">
                  <Input
                    onChange={onChange}
                    label={"Dirección"}
                    name={"sala-direccion"}
                    type={"text"}
                    value={data?.sala?.direccion}
                    svg={'<i class="bi bi-house-door"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-4 col-12">
                  <Input
                    onChange={onChange}
                    label={"Localidad"}
                    name={"sala-localidad"}
                    type={"text"}
                    value={data?.sala?.localidad}
                    svg={'<i class="bi bi-geo"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-4 col-12 my-2">
                  <label className="form-label d-flex align-items-center mb-2">
                    <i className="bi bi-map text-secondary me-2"></i>
                    <strong>Provincia</strong>
                  </label>
                  <select
                    className="form-select border shadow-sm"
                    name="sala-provincia"
                    onChange={(e) => onChange(e)}
                  >
                    <option selected>{data?.sala?.provincia}</option>
                    {provincias.map((provincia, idx) => (
                      <option key={idx} value={provincia.provincia}>
                        {provincia.provincia}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-12 mt-4">
                  <h6 className="mb-3 d-flex align-items-center">
                    <i className="bi bi-images text-secondary me-2"></i>
                    Galería de imágenes
                  </h6>
                  <div className="card border-0 bg-light mb-3">
                    <div className="card-body">
                      <p className="text-muted small mb-2">
                        <i className="bi bi-info-circle me-1"></i>
                        Tamaño recomendado: 1080 x 1080 px
                      </p>
                      <Input
                        onChange={onChange}
                        name={"sala-imagen_logo"}
                        type={"file"}
                        value={""}
                        svg={'<i class="bi bi-upload"></i>'}
                        validate={{}}
                        disabled={false}
                      />
                    </div>
                  </div>
                  <div className="row g-3">
                    {SalaImages(data?.sala).map((img, index) => (
                      <div key={index} className="col-md-4 col-6">
                        <div className="position-relative">
                          <div
                            className="overflow-hidden shadow-sm border border-2 border-white rounded"
                            style={{height: "200px"}}
                          >
                            <img
                              src={img}
                              alt={`Galería ${index + 1}`}
                              className="w-100 h-100"
                              style={{objectFit: "cover"}}
                            />
                          </div>
                          <button
                            className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                            name="eliminar-image-galeria"
                            onClick={(e) => onClick(e, index+1)}
                            title="Eliminar imagen"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Facturación Tab */}
          {activeTab === 'facturacion' && !isEspectador && (
            <div className="bg-white shadow-sm rounded-3 p-4">
              <h5 className="mb-4 pb-2 border-bottom d-flex align-items-center">
                <i className="bi bi-receipt text-secondary me-2"></i>
                Datos de Facturación
              </h5>
              <div className="row">
                <div className="col-md-6 col-12">
                  <Input
                    onChange={(e) => onChange(e)}
                    label={"CUIT"}
                    name={"entidad"}
                    type={"text"}
                    value={facturacion?.entidad}
                    svg={'<i class="bi bi-file-earmark-text"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <Input
                    onChange={(e) => onChange(e)}
                    label={"CBU"}
                    name={"cbu"}
                    type={"text"}
                    value={facturacion?.cbu}
                    svg={'<i class="bi bi-bank"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>
                <div className="col-md-6 col-12 my-2">
                  <label className="form-label d-flex align-items-center mb-2">
                    <i className="bi bi-clipboard-data text-secondary me-2"></i>
                    <strong>Condición Fiscal</strong>
                  </label>
                  <select
                    className="form-select border shadow-sm"
                    name="dato_fiscal"
                    value={facturacion?.dato_fiscal || ""}
                    onChange={(e) => onChange(e)}
                  >
                    <option value="">Seleccionar condición fiscal</option>
                    <option value="Responsable_inscripto">Responsable Inscripto</option>
                    <option value="IVA_Exento">IVA Exento</option>
                    <option value="Monotributo">Monotributo</option>
                  </select>
                </div>
                <div className="col-md-6 col-12">
                  <Input
                    onChange={(e) => onChange(e)}
                    label={"Porcentaje de comisión (%)"}
                    name={"porcentaje"}
                    type={"number"}
                    value={facturacion?.porcentaje}
                    svg={'<i class="bi bi-percent"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                </div>

                <div className="col-12 mt-4">
                  <h6 className="mb-3 d-flex align-items-center">
                    <i className="bi bi-paperclip text-secondary me-2"></i>
                    Comprobantes
                  </h6>
                </div>
                <div className="col-md-6 col-12">
                  <label className="form-label d-flex align-items-center mb-2">
                    <i className="bi bi-file-earmark-pdf text-danger me-2"></i>
                    Comprobante AFIP
                  </label>
                  <Input
                    onChange={(e) => onChange(e)}
                    label={null}
                    name={"comprobante_afip"}
                    type={"file"}
                    value={""}
                    svg={'<i class="bi bi-upload"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                  {filePreview?.comprobante_afip && (
                    <div className="mt-2 card border-0 bg-light">
                      <div className="card-body p-2">
              {filePreview.comprobante_afip.isExisting ? (
                // Archivo existente desde el servidor (Object URL en caché)
                <div>
                  {filePreview.comprobante_afip.type?.includes('pdf') ||
                   filePreview.comprobante_afip.fileName?.toLowerCase().endsWith('.pdf') ? (
                    <a
                      href={filePreview.comprobante_afip.url}
                      download={filePreview.comprobante_afip.fileName}
                      className="alert alert-info d-inline-block text-decoration-none"
                      style={{cursor: 'pointer'}}
                    >
                      <i className="fas fa-file-pdf me-2"></i>
                      {filePreview.comprobante_afip.fileName}
                      <small className="ms-2">(Click para descargar)</small>
                    </a>
                  ) : filePreview.comprobante_afip.type?.includes('image') ? (
                    <a
                      href={filePreview.comprobante_afip.url}
                      download={filePreview.comprobante_afip.fileName}
                      title="Click para descargar"
                    >
                      <img
                        src={filePreview.comprobante_afip.url}
                        alt="Comprobante AFIP"
                        className="img-thumbnail"
                        style={{maxWidth: "150px", maxHeight: "100px", objectFit: "cover"}}
                      />
                    </a>
                  ) : (
                    <a
                      href={filePreview.comprobante_afip.url}
                      download={filePreview.comprobante_afip.fileName}
                      className="alert alert-secondary d-inline-block text-decoration-none"
                      style={{cursor: 'pointer'}}
                    >
                      <i className="fas fa-file me-2"></i>
                      {filePreview.comprobante_afip.fileName}
                      <small className="ms-2">(Click para descargar)</small>
                    </a>
                  )}
                </div>
              ) : typeof filePreview.comprobante_afip === 'string' && filePreview.comprobante_afip !== 'pdf' ? (
                <img
                  src={filePreview.comprobante_afip}
                  alt="Vista previa"
                  className="img-thumbnail"
                  style={{maxWidth: "150px", maxHeight: "100px", objectFit: "cover"}}
                />
              ) : filePreview.comprobante_afip === 'pdf' ? (
                <div className="alert alert-info d-inline-block">
                  <i className="fas fa-file-pdf me-2"></i>
                  PDF seleccionado
                </div>
              ) : (
                <div className="alert alert-secondary d-inline-block">
                  <i className="fas fa-file me-2"></i>
                  {filePreview.comprobante_afip}
                </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-md-6 col-12">
                  <label className="form-label d-flex align-items-center mb-2">
                    <i className="bi bi-file-earmark-pdf text-danger me-2"></i>
                    Comprobante CBU
                  </label>
                  <Input
                    onChange={(e) => onChange(e)}
                    label={null}
                    name={"comprobante_cbu"}
                    type={"file"}
                    value={""}
                    svg={'<i class="bi bi-upload"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                  {filePreview?.comprobante_cbu && (
                    <div className="mt-2 card border-0 bg-light">
                      <div className="card-body p-2">
              {filePreview.comprobante_cbu.isExisting ? (
                // Archivo existente desde el servidor (Object URL en caché)
                <div>
                  {filePreview.comprobante_cbu.type?.includes('pdf') ||
                   filePreview.comprobante_cbu.fileName?.toLowerCase().endsWith('.pdf') ? (
                    <a
                      href={filePreview.comprobante_cbu.url}
                      download={filePreview.comprobante_cbu.fileName}
                      className="alert alert-info d-inline-block text-decoration-none"
                      style={{cursor: 'pointer'}}
                    >
                      <i className="fas fa-file-pdf me-2"></i>
                      {filePreview.comprobante_cbu.fileName}
                      <small className="ms-2">(Click para descargar)</small>
                    </a>
                  ) : filePreview.comprobante_cbu.type?.includes('image') ? (
                    <a
                      href={filePreview.comprobante_cbu.url}
                      download={filePreview.comprobante_cbu.fileName}
                      title="Click para descargar"
                    >
                      <img
                        src={filePreview.comprobante_cbu.url}
                        alt="Comprobante CBU"
                        className="img-thumbnail"
                        style={{maxWidth: "150px", maxHeight: "100px", objectFit: "cover"}}
                      />
                    </a>
                  ) : (
                    <a
                      href={filePreview.comprobante_cbu.url}
                      download={filePreview.comprobante_cbu.fileName}
                      className="alert alert-secondary d-inline-block text-decoration-none"
                      style={{cursor: 'pointer'}}
                    >
                      <i className="fas fa-file me-2"></i>
                      {filePreview.comprobante_cbu.fileName}
                      <small className="ms-2">(Click para descargar)</small>
                    </a>
                  )}
                </div>
              ) : typeof filePreview.comprobante_cbu === 'string' && filePreview.comprobante_cbu !== 'pdf' ? (
                <img
                  src={filePreview.comprobante_cbu}
                  alt="Vista previa"
                  className="img-thumbnail"
                  style={{maxWidth: "150px", maxHeight: "100px", objectFit: "cover"}}
                />
              ) : filePreview.comprobante_cbu === 'pdf' ? (
                <div className="alert alert-info d-inline-block">
                  <i className="fas fa-file-pdf me-2"></i>
                  PDF seleccionado
                </div>
              ) : (
                <div className="alert alert-secondary d-inline-block">
                  <i className="fas fa-file me-2"></i>
                  {filePreview.comprobante_cbu}
                </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-md-6 col-12">
                  <label className="form-label d-flex align-items-center mb-2">
                    <i className="bi bi-file-earmark-pdf text-danger me-2"></i>
                    Comprobante Entidad
                  </label>
                  <Input
                    onChange={(e) => onChange(e)}
                    label={null}
                    name={"comprobante_entidad"}
                    type={"file"}
                    value={""}
                    svg={'<i class="bi bi-upload"></i>'}
                    validate={{}}
                    disabled={false}
                  />
                  {filePreview?.comprobante_entidad && (
                    <div className="mt-2 card border-0 bg-light">
                      <div className="card-body p-2">
              {filePreview.comprobante_entidad.isExisting ? (
                // Archivo existente desde el servidor (Object URL en caché)
                <div>
                  {filePreview.comprobante_entidad.type?.includes('pdf') ||
                   filePreview.comprobante_entidad.fileName?.toLowerCase().endsWith('.pdf') ? (
                    <a
                      href={filePreview.comprobante_entidad.url}
                      download={filePreview.comprobante_entidad.fileName}
                      className="alert alert-info d-inline-block text-decoration-none"
                      style={{cursor: 'pointer'}}
                    >
                      <i className="fas fa-file-pdf me-2"></i>
                      {filePreview.comprobante_entidad.fileName}
                      <small className="ms-2">(Click para descargar)</small>
                    </a>
                  ) : filePreview.comprobante_entidad.type?.includes('image') ? (
                    <a
                      href={filePreview.comprobante_entidad.url}
                      download={filePreview.comprobante_entidad.fileName}
                      title="Click para descargar"
                    >
                      <img
                        src={filePreview.comprobante_entidad.url}
                        alt="Comprobante Entidad"
                        className="img-thumbnail"
                        style={{maxWidth: "150px", maxHeight: "100px", objectFit: "cover"}}
                      />
                    </a>
                  ) : (
                    <a
                      href={filePreview.comprobante_entidad.url}
                      download={filePreview.comprobante_entidad.fileName}
                      className="alert alert-secondary d-inline-block text-decoration-none"
                      style={{cursor: 'pointer'}}
                    >
                      <i className="fas fa-file me-2"></i>
                      {filePreview.comprobante_entidad.fileName}
                      <small className="ms-2">(Click para descargar)</small>
                    </a>
                  )}
                </div>
              ) : typeof filePreview.comprobante_entidad === 'string' && filePreview.comprobante_entidad !== 'pdf' ? (
                <img
                  src={filePreview.comprobante_entidad}
                  alt="Vista previa"
                  className="img-thumbnail"
                  style={{maxWidth: "150px", maxHeight: "100px", objectFit: "cover"}}
                />
              ) : filePreview.comprobante_entidad === 'pdf' ? (
                <div className="alert alert-info d-inline-block">
                  <i className="fas fa-file-pdf me-2"></i>
                  PDF seleccionado
                </div>
              ) : (
                <div className="alert alert-secondary d-inline-block">
                  <i className="fas fa-file me-2"></i>
                  {filePreview.comprobante_entidad}
                </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Usuario;
